import { i18nMark } from 'lingui-react';

const messages = {
  title: i18nMark('Request Service'),
};

export default messages;



// WEBPACK FOOTER //
// ./compositions/RequestServiceButton/messages.js